/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'projectsoverview': {
    width: 15,
    height: 11,
    viewBox: '0 0 15 11',
    data: '<path pid="0" d="M.362 6.14h14.03v4.65H.361V6.14zm0-5.648h7.624v4.65H.362V.493zm8.453 0h5.576v4.65H8.815V.493z" _fill="#03A7FA" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/projectsoverview.js